import { render, staticRenderFns } from "./SuperAdminCreateOperatorGroup.vue?vue&type=template&id=6dbe039b&scoped=true&lang=pug&functional=true"
var script = {}
import style0 from "./SuperAdminCreateOperatorGroup.vue?vue&type=style&index=0&id=6dbe039b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6dbe039b",
  null
  
)

export default component.exports